module.exports = __webpack_public_path__ + "static/media/img2.3dbe45bf.PNG";